export default __webpack_public_path__ + "static/media/0.6.7b1a4201.jpg";